import React from 'react'
import { Box } from '@mui/material'
import { PTitles } from '../../../types/carbon/models/PTitles'
import { PCorner } from '../../../types/carbon/models/PCorner'
import { SettingsSwitch, SettingsSelect, SettingsRow } from './SettingsControls'

interface TitlesSectionProps {
  titles: PTitles
  corner: PCorner
  description: string
  onTitlesChange: (titles: PTitles) => void
  onCornerChange: (corner: PCorner) => void
  onDescriptionChange: (description: string) => void
}

const priorityOptions = [
  { value: 'Side', label: 'Side' },
  { value: 'Top', label: 'Top' },
]

const TitlesSection: React.FC<TitlesSectionProps> = ({
  titles,
  corner,
  description,
  onTitlesChange,
  onCornerChange,
  onDescriptionChange,
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      <SettingsRow>
        <SettingsSwitch label="Name" checked={titles.name} onChange={v => onTitlesChange({ ...titles, name: v })} />
        <SettingsSwitch label="Top" checked={titles.top} onChange={v => onTitlesChange({ ...titles, top: v })} />
        <SettingsSwitch label="Side" checked={titles.side} onChange={v => onTitlesChange({ ...titles, side: v })} />
      </SettingsRow>
      <SettingsRow>
        <SettingsSwitch label="Filter" checked={titles.filter} onChange={v => onTitlesChange({ ...titles, filter: v })} />
        <SettingsSwitch label="Weight" checked={titles.weight} onChange={v => onTitlesChange({ ...titles, weight: v })} />
        <SettingsSwitch label="Status" checked={titles.status} onChange={v => onTitlesChange({ ...titles, status: v })} />
      </SettingsRow>

      <SettingsSelect
        label="Corner Priority"
        value={corner.priority}
        options={priorityOptions}
        onChange={v => onCornerChange({ ...corner, priority: v as PCorner['priority'] })}
      />
      <SettingsSwitch label="Net Resp" checked={corner.netResp} onChange={v => onCornerChange({ ...corner, netResp: v })} />
    </Box>
  )
}

export default TitlesSection
